import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Icons } from './icon-set';


@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less']
})
export class IconComponent {

  @Input() name: string = '';
  @Input() shadow?: boolean = false;

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  public getSVG = (): SafeHtml => {

    const shadow = this.shadow ? `class="svg-shadow"` : ``;

    const svg = `<svg ` + shadow +  ` version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 600">` + Icons[this.name] + `</svg>`

    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

}




